// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import i18n from '../../i18n';

// Money moved from one card of a gateway to another: the "from" wallet's takings
// go down and the "to" wallet's up, in the gateway's currency. Both ends are
// required (400 without) and must differ, and both must be wallets of the chosen
// gateway, which the backend enforces. The gateway's balance is not affected.
export default class WalletTransfersPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingWalletTransfers';
        this.Server = this.props.context.getState().server.accountingWalletTransfers;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'note'];

        const walletEnd = {
            required: true,
            alignRight: false,
            cell: 'Select',
            from: 'publicWallets',
            show: 'uuid',
            displayGrid: true
        };

        const defaultHead = [
            { id: 'uuid', label: 'uuid', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            {
                id: 'gatewayId', required: true,
                label: 'gateway',
                alignRight: false,
                cell: 'Select',
                from: 'publicGateways',
                object: 'gateway',
                show: 'name',
                displayGrid: true
            },
            {
                ...walletEnd,
                id: 'fromWalletId',
                label: 'fromWallet',
                object: 'fromWallet',
                helperText: 'walletTransferFrom'
            },
            // The API refuses a transfer from a wallet to itself; said here, on the
            // second end, before the round trip.
            {
                ...walletEnd,
                id: 'toWalletId',
                label: 'toWallet',
                object: 'toWallet',
                helperText: 'walletTransferTo',
                validate: (value, values) =>
                    value == null ||
                    values?.fromWalletId == null ||
                    value !== values.fromWalletId ||
                    i18n.t('errors.walletTransferSameWallet')
            },
            // In the gateway's currency, the one takings are in, which the backend
            // stamps on the row as its currency.
            {
                id: 'amount', required: true,
                label: 'amount',
                alignRight: true,
                cell: 'Amount',
                currencyObject: 'currency',
                helperText: 'walletTransferAmount',
                displayGrid: true
            },
            { id: 'note', label: 'note', alignRight: false, cell: 'BigText', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
